const initialState = {
  apiData: null,
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_API_RESPONSE":
      return { ...state, apiData: action.payload };
    default:
      return state;
  }
};

export default dataReducer;
